<template>
  <button
    v-bind="$attrs"
    v-on="$listeners"
    :class="`${btnStyle} ${loading ? 'my-loading' : ''} ${hasVModel && isPressed ? 'active' : ''}`"
    class="tw-rounded-full tw-border-[1px] tw-border-transparent"
    @click="handleClick"
  >
    <slot /><loader v-if="loading" />
    <transition name="fade">
      <icon-close
        class="tw-w-[15px] tw-h-[15px] tw-text=[var(--my-text-color)]"
        v-if="(showCloseIconIfPressed && isPressed) || showCloseIcon"
      />
    </transition>
  </button>
</template>

<script>
import Loader from "@/views/my-contacts/ui/my-loader.vue";
import IconClose from "@/views/my-contacts/icons/close.vue";

export default {
  data() {
    return {
      isPressed: this.value,
    };
  },

  watch: {
    value(newVal) {
      this.isPressed = newVal;
    },
  },

  computed: {
    hasVModel() {
      return "value" in this.$options.propsData;
    },
  },

  methods: {
    handleClick() {
      if (this.loading || !this.hasVModel) return;

      this.isPressed = !this.isPressed;
      this.$emit("input", this.isPressed);
      this.$emit("change", this.isPressed);
    },
  },

  name: "my-btn",

  components: {
    Loader,
    IconClose,
  },

  props: {
    showCloseIcon: {
      type: Boolean,
      default: false,
    },
    showCloseIconIfPressed: {
      type: Boolean,
      default: false,
    },
    btnStyle: {
      type: String,
      default: "my-primary",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.my-primary {
  @apply tw-inline-flex tw-justify-center tw-items-center tw-px-[32px] tw-py-[14px] tw-text-[18px] tw-text-[var(--my-white)] tw-bg-[var(--my-primary)];

  &--mobile-dark-bg {
    @apply tw-bg-[#6BBBFF] md:tw-bg-[var(--my-primary)];
  }

  &--tw-h-40px {
    @apply tw-h-[40px];
    height: 40px;
  }

  &.my-loading {
    color: var(--my-primary);
  }
}

.my-outlined {
  @apply tw-inline-flex tw-justify-center tw-items-center tw-px-[31px] tw-py-[13px] tw-border-2 tw-border-[var(--my-primary)] tw-text-[18px] tw-text-[var(--my-primary)] tw-bg-transparent;
}

.my-ghost-toggleable {
  @apply tw-inline-flex tw-gap-[16px] tw-justify-center tw-items-center tw-px-[20px] tw-py-[13px] tw-text-[18px] tw-text-[#2D3748] tw-bg-transparent tw-transition-colors;

  &.active {
    @apply tw-text-[var(--my-text-color)] tw-bg-[var(--my-btn-state-active-color)];
  }

  &--active-filters {
    @apply tw-px-[20px] tw-py-[9px] tw-text-[16px] tw-text-[var(--my-text-color)] tw-bg-[var(--my-white)] md:tw-bg-[var(--my-search-bg-md)];
  }
}

.my-default-toggleable {
  @apply tw-inline-flex tw-justify-center tw-items-center tw-px-[20px] tw-py-[8px] tw-text-[15px] tw-bg-[var(--my-white-soft)] tw-transition-colors;

  &.active {
    @apply tw-text-[var(--my-white)] tw-bg-[var(--my-primary)];
  }
}

.my-loading {
  color: var(--my-primary);
  pointer-events: none;
  user-select: none;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 150ms;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
